export default __webpack_public_path__ + "images/arrow_left-5b65f1e8013cebc5124c7e225c15681d.svg";